import { render, staticRenderFns } from "./ModulesCreateModal.vue?vue&type=template&id=6a155b56&scoped=true&"
import script from "./ModulesCreateModal.vue?vue&type=script&lang=js&"
export * from "./ModulesCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./ModulesCreateModal.vue?vue&type=style&index=0&id=6a155b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a155b56",
  null
  
)

export default component.exports